import { useTranslation } from 'react-i18next';

import { Pictogram } from '@hotjar/hotsauce';
import { useOwnedAccount } from '@hotjar/account';

import { BillingAlert } from './BillingAlert';

export const MoneyBackGuaranteeBanner = (): JSX.Element => {
  const { t } = useTranslation();

  const { data: ownedAccount } = useOwnedAccount();

  const { currency = 'eur' } = ownedAccount ?? {};

  return (
    <BillingAlert
      icon={<Pictogram variant={`money_back_${currency}`} />}
      title={t('revenue:plans-and-billing-page.alerts.money-back-guarantee.title')}
      subtitle={t('revenue:plans-and-billing-page.alerts.money-back-guarantee.subtitle')}
    />
  );
};
